import { setUserPropsFromQuery } from '@brighterly/lib-core-functions/analytics'

import { useCustomerStore } from '../model/customer-store/store'

const sentFor = new Set<number>()

/**
 * Customer-level user props, once per customer per page load. `setUserPropsFromQuery` is the lib's only post-init
 * identify: each name also gets a setOnce `initial_` twin (spec, "User props").
 */
export const setCustomerUserProps = (): void => {
  const store = useCustomerStore()
  const customer = store.customer
  if (!customer || sentFor.has(customer.id)) return
  sentFor.add(customer.id)

  const marketingData = store.getMarketingData
  const hasMarketingData = !!marketingData && Object.keys(marketingData).length > 0

  setUserPropsFromQuery({
    ...(store.getExperiments ?? {}),
    ...(hasMarketingData ? { 'marketing-data': JSON.stringify(marketingData) } : {}),
    ai_summarize_flag: String(store.isAiSummary),
  })
}
